import React from 'react';
import * as LucideIcons from 'lucide-react';

const cache = new Map();
const toPascal = (name) =>
  name.split('-').map(p => (p[0] || '').toUpperCase() + p.slice(1)).join('');

function resolveIcon(name) {
  if (!name) return null;
  if (cache.has(name)) return cache.get(name);
  const Cmp = LucideIcons[toPascal(name)] || LucideIcons[name] || null;
  cache.set(name, Cmp);
  return Cmp;
}

const Icon = ({ name, size = 16, color, strokeWidth = 1.75, className, style, ...rest }) => {
  const Cmp = resolveIcon(name);
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      color={color || 'currentColor'}
      strokeWidth={strokeWidth}
      className={className}
      style={{ display: 'inline-flex', flexShrink: 0, ...style }}
      {...rest}
    />
  );
};

export default Icon;
